"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.isValidProduct = exports.isRuleProduct = exports.isNotFreeTripInsurance = exports.isFreeTripInsurance = exports.isFlightProduct = exports.isFlightOrder = exports.isFlightCart = exports.isDisplayable = exports.isAddonProduct = exports.isAddOnCart = exports.isAddOnApplied = exports.extractProduct = exports.extractAddonFromSale = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isValidProduct = exports.isValidProduct = function isValidProduct(p) {
  return p.valid;
};
var isFlightProduct = exports.isFlightProduct = function isFlightProduct(p) {
  return p.type === "flight";
};
var isFlightCart = exports.isFlightCart = function isFlightCart(p) {
  return p.type === "flight";
};
var isFlightOrder = exports.isFlightOrder = function isFlightOrder(p) {
  return p.orderType === "flight";
};
var isAddOnApplied = exports.isAddOnApplied = function isAddOnApplied(code) {
  return function (p) {
    return (0, _get2.default)(p, "options.miscellaneous.packageInfo.id", "") === code;
  };
};
var isRuleProduct = exports.isRuleProduct = function isRuleProduct(p) {
  return p.type === "rule" && p.category === "rule";
};
var isDisplayable = exports.isDisplayable = function isDisplayable(p) {
  var displayRule = (0, _get2.default)(p, "options.displayRule", "");
  return isRuleProduct(p) && displayRule !== _constants.ADDON_MERGE_ALL;
};
var isFreeTripInsurance = exports.isFreeTripInsurance = function isFreeTripInsurance(addon) {
  return addon.code === _constants.ADDONS.INSURANCE;
};
var isNotFreeTripInsurance = exports.isNotFreeTripInsurance = function isNotFreeTripInsurance(addon) {
  return addon.code !== _constants.ADDONS.INSURANCE;
};
var isAddOnCart = exports.isAddOnCart = function isAddOnCart(c) {
  var _c$relatedToCart, _c$relatedToCart2;
  return (c === null || c === void 0 ? void 0 : (_c$relatedToCart = c.relatedToCart) === null || _c$relatedToCart === void 0 ? void 0 : _c$relatedToCart.relationType) === "Addons" && (c === null || c === void 0 ? void 0 : (_c$relatedToCart2 = c.relatedToCart) === null || _c$relatedToCart2 === void 0 ? void 0 : _c$relatedToCart2.cartProductType) === "flight";
};
var isAddonProduct = exports.isAddonProduct = function isAddonProduct(p) {
  var _p$options;
  return !(0, _isEmpty2.default)(p === null || p === void 0 ? void 0 : (_p$options = p.options) === null || _p$options === void 0 ? void 0 : _p$options.miscellaneous);
};
var extractAddonFromSale = exports.extractAddonFromSale = function extractAddonFromSale(addonCartList) {
  return (0, _map2.default)(addonCartList, function (addonCart) {
    var _addonCart$products;
    var addonProduct = (_addonCart$products = addonCart.products) === null || _addonCart$products === void 0 ? void 0 : _addonCart$products.find(isAddonProduct);
    return extractProduct(addonProduct, addonCart === null || addonCart === void 0 ? void 0 : addonCart.cartId);
  });
};
var extractProduct = exports.extractProduct = function extractProduct(addonProduct, cartId) {
  if (!(0, _isEmpty2.default)(addonProduct)) {
    var _addonProduct$options, _addonProduct$options2;
    return _objectSpread(_objectSpread({}, addonProduct), {}, {
      package: addonProduct === null || addonProduct === void 0 ? void 0 : (_addonProduct$options = addonProduct.options) === null || _addonProduct$options === void 0 ? void 0 : (_addonProduct$options2 = _addonProduct$options.miscellaneous) === null || _addonProduct$options2 === void 0 ? void 0 : _addonProduct$options2.packageInfo,
      cartId: cartId
    });
  }
  return {};
};